import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const IntendedUse: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();

  return (
    <>
      <h2>{t('about.intendedUse.title')}</h2>
      <p>{tRegion('about.intendedUse.text.paragraph_1')}</p>
    </>
  );
};
